<div class="card card-shadow">
    <div class="card-body">
        <div class="d-flex justify-content-start align-items-center mb-3">
            <img src="/assets/img/leader/Pradhan-Dharmendra_01.png" style="height: 96px;" class="img-fluid rounded shadow" alt="...">
            <div class="ml-3">
                <h6 class="fw-bold text-default text-uppercase mb-1">Shri Dharmendra Pradhan</h6>
                <p>Hon'ble Minister of Education</p>
            </div>
        </div>
        <div class="d-flex justify-content-start align-items-center mb-3">
          <img src="/assets/img/leader/jchaudhry.png" style="height: 96px;" class="img-fluid rounded shadow" alt="...">
          <div class="ml-3">
            <h6 class="fw-bold text-default text-uppercase mb-1">Mr Jayant Chaudhary</h6>
            <p>Hon'ble Minister of State for MoE</p>
          </div>
      </div>
        <div class="d-flex justify-content-start align-items-center mb-3">
            <img src="/assets/img/leader/rajesh-lakhani.png" style="height: 96px;" class="img-fluid rounded shadow" alt="...">
            <div class="ml-3">
                <h6 class="fw-bold text-default text-uppercase mb-1">Shri Rajesh Lakhani (IAS)</h6>
                <p>Commissioner, NVS</p>
            </div>
        </div>
    </div>
</div>
